// http://iamnotmyself.com/2020/02/14/implementing-websocket-plugins-for-vuex/
import ROSLIB from "roslib";
var ros = new ROSLIB.Ros({ url: process.env.VUE_APP_ROS_SERVER_URL });
// var ros = new ROSLIB.Ros({ url: "wss://localhost:4040/" });

var listener = new ROSLIB.Topic({
  ros: ros,
  name: "/diagnostics",
  messageType: "diagnostic_msgs/DiagnosticArray",
});

var listener_direction = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/row_controller/driving_direction",
  messageType: "std_msgs/String",
});

var listener_battery = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/power/battery_level",
  messageType: "std_msgs/Int16",
});

var listener_speed = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/rover_manager/speed",
  messageType: "std_msgs/Float32",
});

var listener_time_left = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/calculated_stats/time_left",
  messageType: "std_msgs/Int16",
});

var listener_farms = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/gui/config",
  messageType: "std_msgs/String",
});

var listener_error = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/gui_error",
  messageType: "std_msgs/String",
});

var listener_emergency = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/emergency",
  messageType: "std_msgs/String",
});

var listener_mapping_state = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/mapping_state",
  messageType: "std_msgs/String",
});

var listener_harvest_state = new ROSLIB.Topic({
  ros: ros,
  name: "automato/harvester/state",
  messageType: "std_msgs/String",
});

var listener_harvest_eta = new ROSLIB.Topic({
  ros: ros,
  name: "automato/harvester/eta",
  messageType: "std_msgs/Int16",
});

var listener_harvest_progress = new ROSLIB.Topic({
  ros: ros,
  name: "automato/harvester/progress",
  messageType: "std_msgs/Int16",
});

var listener_harvest_boxes = new ROSLIB.Topic({
  ros: ros,
  name: "automato/harvester/boxes",
  messageType: "std_msgs/Int16",
});

var listener_settings = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/gui/settings",
  messageType: "std_msgs/String",
});
// var listener_location = new ROSLIB.Topic({
//   ros : ros,
//   name: '/map/pose/stamped',
//   messageType: 'geometry_msgs/PoseWithCovarianceStamped'
// });

var listener_sprayed_rows = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/sprayed_rows",
  messageType: "std_msgs/Int16",
});

var listener_sprayed_eta = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/eta",
  messageType: "std_msgs/Int16",
});

var listener_spraying_rover_status = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/status",
  messageType: "std_msgs/String",
});

var listener_splaying_percentage = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/sprayed_percentage",
  messageType: "std_msgs/Int16",
});

var listener_splaying_rate = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/rate",
  messageType: "std_msgs/Int16",
});

var listener_splaying_tank_error = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/tank_sensor",
  messageType: "std_msgs/Bool",
});

var listener_splaying_pump_error = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/pressure_problem",
  messageType: "std_msgs/Bool",
});

var listener_splaying_valve_error = new ROSLIB.Topic({
  ros: ros,
  name: "/automato/sprayer_node/valve_problem",
  messageType: "std_msgs/Bool",
});

export default function createChatSocketPlugin() {
  return (store) => {
    listener.subscribe(function(message) {
      store.dispatch("chat/setSecs", message.header.stamp.secs);
      let b = JSON.stringify(message.status[0].values);
      let c = JSON.parse(b);
      let totalMemory = c.find((element) => element.key == "Total Memory");
      let freeMemory = c.find((element) => element.key == "Free Memory");

      if (totalMemory && freeMemory) {
        let memory =
          (parseFloat(freeMemory.value.replace("M", "")) /
            parseFloat(totalMemory.value.replace("M", ""))) *
          100;
        memory = Math.floor(memory).toString() + "%";
        store.dispatch("chat/setAttribute", { memory: memory });
      }

      let diskUsage = c.find((element) => element.key == "Disk 1 Use");
      if (diskUsage) {
        store.dispatch("chat/setAttribute", { diskUsage: diskUsage.value });
      }

      if (message.status[1]) {
        let d = JSON.stringify(message.status[1].values);
        let e = JSON.parse(d);
        let cpu = e.find((element) => element.key == "Load Average (1min)");
        if (cpu) {
          store.dispatch("chat/setAttribute", { cpu: cpu.value });
        }
      }
    });

    listener_direction.subscribe(function(message) {
      store.dispatch("chat/setDrivingDirection", message.data);
    });

    listener_battery.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { battery: message.data });
    });

    listener_speed.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { speed: message.data });
    });

    listener_time_left.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { timeLeft: message.data });
    });

    var loadData = function(str) {
      let data = null;
      try {
        data = JSON.parse(str);
      } catch (error) {
        console.log("Error loading data");
        console.error(error);
      }
      if (data == undefined || data == null) {
        console.log("Discarding empty data");
      }
      return data;
    };

    listener_settings.subscribe(function(message) {
      let settings = loadData(message.data);

      if (settings == null) {
        return;
      }
      if (store.state.selectedTomato != settings.redness) {
        store.dispatch("selectedTomatoInit", settings.redness);
      }
      if (store.state.confirmationRequired != settings.confirmationRequired) {
        store.dispatch(
          "confirmationRequiredInit",
          settings.confirmationRequired
        );
      }
      if (store.state.tomatoesPerBox != settings.tomatoesPerBox) {
        store.dispatch("tomatoesPerBoxInit", settings.tomatoesPerBox);
      }

      console.log(
        "Received message on " + listener_settings.name + ": " + message.data
      );
    });

    listener_farms.subscribe(function(message) {
      let farms = loadData(message.data);

      if (farms != null && farms != {}) {
        store.dispatch("farms/setFarms", farms);
      }
      console.log(
        "Received message on " + listener_farms.name + ": " + message.data
      );
    });

    listener_error.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { modalTitle: "Error" });
      store.dispatch("chat/setAttribute", { modalBody: message.data });
      store.dispatch("chat/setAttribute", { showModal: true });
      console.log(
        "Received message on " + listener_error.name + ": " + message.data
      );
    });

    listener_emergency.subscribe(function(message) {
      // store.dispatch('chat/setAttribute', { time_left: message.data });
      console.log(
        "Received message on " + listener_emergency.name + ": " + message.data
      );
    });

    listener_mapping_state.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { mappingState: message.data });
      if (message.data == "finished") {
        store.dispatch("chat/setAttribute", { modalTitle: "Mapping complete" });
        store.dispatch("chat/setAttribute", {
          modalBody: "Please click on the home icon and place on map",
        });
        store.dispatch("chat/setAttribute", { showModal: true });
      }
      console.log(
        "Received message on " +
          listener_mapping_state.name +
          ": " +
          message.data
      );
    });

    // listener_location.subscribe(function(message) {
    //   // store.dispatch('chat/setAttribute', { time_left: message.data });
    //   // debugger
    //   // console.log('Received message on ' + listener_location.name + ': ' + message.pose.pose.position.x);
    // });

    listener_harvest_state.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { harvestingState: message.data });
      console.log(
        "Received message on " +
          listener_harvest_state.name +
          ": " +
          message.data
      );
    });

    listener_harvest_eta.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { harvestingEta: message.data });
      // console.log('Received message on ' + listener_harvest_eta.name + ': ' + message.data);
    });

    listener_harvest_progress.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { harvestingProgress: message.data });
      // console.log('Received message on ' + listener_harvest_progress.name + ': ' + message.data);
    });

    listener_harvest_boxes.subscribe(function(message) {
      store.dispatch("chat/setAttribute", { harvestingBoxes: message.data });
      // console.log('Received message on ' + listener_harvest_boxes.name + ': ' + message.data);
    });

    listener_sprayed_rows.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", {
        SprayedRows: message.data,
      });
    });

    listener_sprayed_eta.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", { SprayedEta: message.data });
    });

    listener_spraying_rover_status.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", {
        SprayerRoverStatus: message.data,
      });
    });

    listener_splaying_percentage.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", {
        SprayendPercentage: message.data,
      });
    });

    listener_splaying_rate.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", { SprayRate: message.data });
    });

    listener_splaying_tank_error.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", {
        SprayTankError: message.data,
      });
    });

    listener_splaying_pump_error.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", {
        SprayPumpError: message.data,
      });
    });

    listener_splaying_valve_error.subscribe(function(message) {
      store.dispatch("chat/setSprayingAttribute", {
        SprayValveError: message.data,
      });
    });

    ros.on("connection", (oldState, newState) => {
      console.log("Connected to websocket server.");
      store.dispatch("chat/connectionOpened");
    });

    ros.on("error", (oldState, newState) => {
      console.log("Connection error to websocket server.");
      store.dispatch("chat/connectionClosed");
    });

    ros.on("close", function() {
      console.log("Connection to websocket server closed.");
      store.dispatch("chat/connectionClosed");
    });
  };
}
